// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3697":"af1167e1","3860":"bc894d8e","4805":"ca65f85a","5901":"af1167e1","7735":"358c586b","9223":"af1167e1"}[chunkId] + ".chunk.css";
};